import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";

Vue.config.productionTip = false;

fetch(`${process.env.BASE_URL}appData.json`)
  .then(response => {
    return response.json();
  })
  .then(data => {
    store.commit("setData", data);

    new Vue({
      router,
      store,
      render: h => h(App)
    }).$mount("#app");
  })
  .catch(err => {
    console.log(`Error fetchin appData.json: ${err}`);
  });
